"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledgeProject.description.placeholder': 'Wprowadź opis projektu',
};
